import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './Modals.scss';
import ModalClose from './ModalClose';
import ModalTitle from './ModalTitle';

function ModalHeader({ children, type, withIcon, onCloseClick }) {
    return (<header className={styles[`modal-header-${withIcon ? 'with-icon' : 'normal'}`]}>
        <ModalClose onClick={onCloseClick} />
        <ModalTitle type={type}>
            {children}
        </ModalTitle>
    </header>)
}

ModalHeader.displayName = displayName('Modals/ModalHeader');

ModalHeader.propTypes = {
    children: PropTypes.node.isRequired,
    type: PropTypes.oneOf(ModalTitle.modalTypes),
    onCloseClick: PropTypes.func.isRequired,
    withIcon: PropTypes.bool,
};

ModalHeader.defaultProps = {
    type: 'normal',
    withIcon: false,
};

export default ModalHeader;
